import parser from 'html-react-parser';
import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const WeMustBuilder = ({ imagineHomeSlides }) => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    speed: 2000,
    autoplaySpeed: 5000,
    autoplay: true,
  };

  return (
    <Slider {...settings}>
      {imagineHomeSlides.map((item, index) => (
        <div key={index}>
          <div className='wemust-text'>
            <h3 className='heading-level-3-i'>
              {parser(item.imagineSlideText)}
            </h3>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default WeMustBuilder;
